/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchAddressRoadOptionsDto } from '../../models/search-address-road-options-dto';

export interface GetRoadSearchOptions$Params {}

export function getRoadSearchOptions(
  http: HttpClient,
  rootUrl: string,
  params?: GetRoadSearchOptions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchAddressRoadOptionsDto>> {
  const rb = new RequestBuilder(rootUrl, getRoadSearchOptions.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchAddressRoadOptionsDto>;
      }),
    );
}

getRoadSearchOptions.PATH = '/search/address/road/options';
